export enum CardDisplayMode {
  Flex = 'flex',
  Block = 'block'
}